import React from 'react';
import { coreAdminApiBalanceApi } from '../api';
import { StatItem } from './statItem';
import { Price } from './price';

export const ZvonokBalance: React.FC = () => {
  const { data, isLoading } = coreAdminApiBalanceApi.endpoints.getApiBalance.useQuery();
  return <StatItem isLoading={isLoading} label="zvonok" title="Текущий баланс Zvonok" value={<Price integer value={data?.zvonok} />} />;
};
